import { useState } from "react";
import { useTranslate } from "../../../../features/translation/hooks/use-translation";
import { TabList } from "../../../../components";
import { AccommodationOnlySearch, FlightOnlySearch, PackageSearch } from "..";

const PRODUCT_TYPES = {
  PACKAGE: "package",
  FLIGHT_ONLY: "flightOnly",
  ACCOMMODATION_ONLY: "accommodationOnly",
};

const ProductSearch = (props) => {
  const [productType, setProductType] = useState(PRODUCT_TYPES.PACKAGE);
  const { t } = useTranslate();

  const PRODUCT_OPTIONS = [
    {
      value: PRODUCT_TYPES.PACKAGE,
      label: t("general.package"),
      icon: "sun-set",
    },
    {
      value: PRODUCT_TYPES.FLIGHT_ONLY,
      label: t("general.flight"),
      icon: "aircraft",
      disabled: true,
    },
    {
      value: PRODUCT_TYPES.ACCOMMODATION_ONLY,
      label: t("general.accommodation"),
      icon: "hotel",
      disabled: true,
    },
  ];
  const renderForm = () => {
    switch (productType) {
      case PRODUCT_TYPES.FLIGHT_ONLY:
        return <FlightOnlySearch />;
      case PRODUCT_TYPES.ACCOMMODATION_ONLY:
        return <AccommodationOnlySearch />;
      case PRODUCT_TYPES.PACKAGE:
      default:
        return <PackageSearch market={props.market} onCustomerTypeChange={props.onCustomerTypeChange} />;
    }
  };

  return (
    <div
      className="container"
      style={{
        backgroundColor: "white",
        boxShadow: "rgba(0, 0, 0, 0.10) 0 1px 3px 0",
        border: "1px solid hsla(203, 50%, 30%, 0.15)",
        borderRadius: "20px",
        padding: " 0 20px 0 20px",
        zIndex: "var(--layer-index-top) !important",
        marginBottom: "80px",
      }}
    >
      <div className="row">
        <TabList
          name="request.product.type"
          options={PRODUCT_OPTIONS}
          value={productType}
          onChange={(e) => setProductType(e.target.value)}
        />
      </div>

      {renderForm()}
    </div>
  );
};

export default ProductSearch;

/*


const Cruise = () => {

    const reset = () => {

    }
    return (
        <>
        
        <div className='row'>
                <div className='col col-12' style={{ display: "flex", justifyContent: "end" }}>
                    <Button
                        label={"Reset fields"}
                        className="ghost medium"
                        style={{ border: 0, textDecoration: "underline" }}
                        onClick={reset}
                    />
                </div>
            </div>
        </>
    )
}

*/
